import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { ImageUploadProgress, MyImageApiService } from 'app/services/image-library/my-image-api.service';
import { TenantLibraryApiService } from 'app/services/image-library/tenant-image-api.service';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-image-upload-progress',
    templateUrl: './image-upload-progress.component.html',
    styleUrls: ['./image-upload-progress.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ImageUploadProgressComponent extends UnsubscribeOnDestroy implements OnInit {
    fileList: File[] | any;
    uploadingImage: ImageUploadProgress;
    uploadStatus: string;
    successCounter = 0;

    constructor(
        public dialogRef: MatDialogRef<ImageUploadProgressComponent>,
        public myImageApiService: MyImageApiService,
        public tenantLibraryApiService: TenantLibraryApiService
    ) {
        super();
    }

    ngOnInit(): void {
        this.myImageApiService.cancelUploadingImages = false;
        this.myImageApiService.inProgressImages$.pipe(takeUntil(this._unsubscribeAll)).subscribe((image) => {
            if (image) {
                this.uploadingImage = image;
            }
        });

        this.tenantLibraryApiService.cancelUploadingImages = false;
        this.tenantLibraryApiService.inProgressImages$.pipe(takeUntil(this._unsubscribeAll)).subscribe((image) => {
            if (image) {
                this.uploadingImage = image;
            }
        });
    }

    cancelUploadImages(): void {
        if (this.uploadingImage) {
            this.myImageApiService.cancelUploadingImage(this.uploadingImage.fileName);
            this.tenantLibraryApiService.cancelUploadingImage(this.uploadingImage.fileName);
        }
        this.myImageApiService.cancelUploadingImages = true;
        this.tenantLibraryApiService.cancelUploadingImages = true;
    }
}
